<script setup lang="ts">
// Material Symbols `home_health` — a house with a plus inside, the dashboard's
// "Expected Payout" glyph: a property on its way to paying out.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 -960 960 960"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M420-280h120v-100h100v-120H540v-100H420v100H320v120h100v100ZM160-120v-480l320-240 320 240v480H160Zm80-80h480v-360L480-740 240-560v360Zm240-270Z"
    />
  </svg>
</template>
